import angkorLife from '@/assets/images/logo/angkorlife-logo.svg';
import LoginForm from './components/login/LoginForm';
import { Typography } from '@/components/Typography';

const Login = () => {
	return (
		<div className="flex flex-col px-4 pt-14 sm:justify-center sm:min-h-screen">
			<header className="flex flex-col items-center gap-4 mb-[30px]">
				<img
					src={angkorLife}
					alt="angkorLife logo"
					className="object-contain w-16 h-16"
				/>
				<Typography variant="h4">Get started with AngkorLife</Typography>
			</header>

			<main>
				<LoginForm />
			</main>
		</div>
	);
};

export default Login;
